import React from 'react';
import { useSelector } from 'react-redux';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import { select } from '@swf/core/store';
import type { GroupProps } from '@swf/core/types/Wizard';

import Transition from './components/Transition/Transition';

const WizardGroup: React.FC<GroupProps> = (props) => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  return <StarsWizard.Group {...props} transition={isEmbedded ? Transition : undefined} />;
};
export default WizardGroup;
